module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC01_ua.7a52e730.webp";